import {
  BooleanInput,
  Create,
  CreateContextProvider,
  Edit,
  EditContextProvider,
  Form,
  required,
  SaveButton,
  SelectInput,
  TextInput,
  Toolbar,
  TopToolbar,
  useCreateController,
  useEditController,
  useNotify,
  useRedirect,
  useRefresh,
  useTranslate,
} from 'react-admin';
import {
  Box,
  Card,
  Divider,
  Stack,
  Typography,
  Button as MUIButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Resources } from '../resource';
import UnlimiteAgentsForm from './UnlimiteAgentsForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const EditUnlimitedAgents = ({ id, open, onClose }: { id: string;  open?: boolean; onClose: () => void }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useEditController({
    resource: Resources.unlimitedAgents,
    id,
    queryOptions: {
      enabled: (open ?? true) && !!id,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
    mutationMode: 'pessimistic',
    mutationOptions: {
      onSuccess: () => {
        notify('module.unlimitedAgents.updateSuccess', { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(error?.body?.message || error?.message || t('ra.notification.http_error'), {
          type: 'warning',
        });
      },
    },
  });

  if (open === false) return null;
  if (!controller.record || controller.isLoading) return null;

  return (
    <EditContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>{t('module.unlimitedAgents.editUnlimitedAgents')}</DialogTitle>
        <DialogContent>
          <UnlimiteAgentsForm isCreate={false} />
        </DialogContent>
        <DialogActions>
          <MUIButton
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          >
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="unlimited-agents" action="update">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </EditContextProvider>
  );
};

export default EditUnlimitedAgents;
